// import store from '@/store/index';
import { post, get } from "@/lin/plugins/axios";
const App_ID = sessionStorage.getItem('appid');

export { post, App_ID, get };
